import React from 'react';
import { useBoolean } from 'react-hanger';
import { Box, Grid } from '@mui/material';
import type { TranslationPath } from 'c-translation';
import { Translate } from 'c-translation';
import { CollapsibleCard, ControlledFormInput, RgbaColorPicker } from 'c-components';
import type { Skin } from 'c-entity-types';

type Props = {
    submitButton: React.ReactNode;
    title: TranslationPath;
    items: ColorSectionItem[];
};

export type ColorSectionItem = {
    key: keyof Skin;
    label: TranslationPath;
};

export const SkinColorGrid: React.FC<{ items: ColorSectionItem[] }> = ({ items }) => (
    <Grid container spacing={2}>
        {items.map(item => (
            <Grid
                key={item.key}
                item
                xs={12}
                sm={6}
                lg={4}
                sx={{ display: 'flex', justifyContent: 'center' }}
            >
                <ControlledFormInput
                    render={({ field }) => (
                        <RgbaColorPicker
                            {...field}
                            label={<Translate path={item.label} />}
                            greyBackdrop={false}
                            whiteBackdrop={false}
                            requireAlpha
                        />
                    )}
                    name={item.key}
                />
            </Grid>
        ))}
    </Grid>
);

const SkinColorSection: React.FC<Props> = ({ submitButton, title, items }) => {
    const open = useBoolean(false);
    return (
        <CollapsibleCard title={title}>
            <Box mb={2} pl={4}>
                {submitButton}
            </Box>
            <SkinColorGrid items={items} />
        </CollapsibleCard>
    );
};

export default SkinColorSection;
